import { Dialog, DialogPanel } from '@headlessui/react'
import { IoMdClose } from 'react-icons/io'
import { useTranslation } from 'react-i18next'

export default function ViewStudentModel({ open, setOpen, student = {} }) {
    const { t } = useTranslation()

    if (!student) {
        return null;
    }
    
    const handleClose = () => setOpen(false)

    const DetailItem = ({ label, value }) => (
        <tr className="border-b last:border-b-0">
            <td className="p-4 text-gray-600 font-medium">{label}</td>
            <td className="p-4 font-semibold text-gray-900">{value || '-'}</td>
        </tr>
    );

    return (
        <Dialog
            open={open}
            as="div"
            className="relative z-30 focus:outline-none"
            onClose={handleClose}
        >
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 bg-black/35 backdrop-blur-sm">
                    <DialogPanel
                        transition
                        className="w-full relative max-w-2xl !rounded-3xl bg-gray-50 duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0"
                    >
                        <div className="p-6 relative z-10">
                            <IoMdClose
                                className="absolute right-5 top-6 cursor-pointer text-gray-600 hover:text-gray-900"
                                fontSize={24}
                                onClick={handleClose}
                            />

                            <div className="bg-white rounded-xl shadow-md overflow-hidden">
                                <div className="p-6 border-b flex items-center space-x-4">
                                    <div className="h-16 w-16 rounded-full bg-gray-200 flex items-center justify-center text-2xl font-bold text-gray-600">
                                        {student.firstName ? student.firstName[0].toUpperCase() : '?'}
                                    </div>
                                    <div>
                                        <h1 className="text-3xl font-bold text-gray-800">
                                            {student.firstName || ''} {student.lastName || ''}
                                        </h1>
                                        <p className="text-md text-gray-500">{student.email}</p>
                                    </div>
                                </div>

                                <div className="p-6">
                                    <h2 className="text-xl font-semibold text-gray-700 mb-4">{t('user_details') || 'User Details'}</h2>
                                    <div className="overflow-x-auto">
                                        <table className="w-full text-left">
                                            <tbody>
                                                <DetailItem label={t('user_id')} value={student.studentId} />
                                                <DetailItem label={t('username')} value={student.username} />
                                                <DetailItem label={t('first_name')} value={student.firstName} />
                                                <DetailItem label={t('last_name')} value={student.lastName} />
                                                <DetailItem label={t('email')} value={student.email} />
                                                <DetailItem label={t('status')} value={<span className={`px-2 py-1 text-sm rounded-full ${student.status === 'ACTIVE' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>{student.status}</span>} />
                                                <DetailItem label={t('preferred_language')} value={student.preferredLanguage} />
                                                <DetailItem label={t('country_code')} value={student.countryCode} />
                                                <DetailItem label={t('gender')} value={student.gender} />
                                                <DetailItem label={t('birth_date')} value={student.birthDate ? new Date(student.birthDate).toLocaleDateString() : '-'} />
                                                <DetailItem label={t('nickname')} value={student.nickname} />
                                                <DetailItem label={t('creation_date')} value={student.creationDate ? new Date(student.creationDate).toLocaleDateString() : '-'} />
                                                <DetailItem
                                                    label={t('roles')}
                                                    value={
                                                        <div className="flex flex-wrap gap-2">
                                                            {student.userRoles?.map((role, index) => (
                                                                <span key={index} className="px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                                    {role.replace('zubrus_', '')}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    }
                                                />
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
} 